import { useTranslation } from "@opendash/i18n";

/**
 * Formats a duration stamp in a human readable format that is either days, hours, minutes or seconds
 * @param duration timestamp as duration in milliseconds
 * @returns a string that represents the duration in a human readable format
 */
export const useDurationFormat = (duration: number) => {
  const t = useTranslation();

  function format(duration: number): string {
    const totalSeconds = Math.floor(duration / 1000);
    // Get the total time in different units
    const days = Math.floor(totalSeconds / (3600 * 24));
    const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    let translationString =
      "maintenance:stats.mean_time_to_recovery.statistic.format.";
    translationString +=
      days > 0
        ? "days"
        : hours > 0
          ? "hours"
          : minutes > 0
            ? "minutes"
            : "seconds";

    return t(translationString, { days, hours, minutes, seconds });
  }

  return format(duration);
};
